import React from 'react';

import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@/components/ui/tooltip';
import { cn } from '@/lib/utils';
import type { SitrepPresenceViewer } from './useSitrepDraftPresence';

function initials(name: string): string {
  const parts = name.trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return '?';
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return `${parts[0][0]}${parts[1][0]}`.toUpperCase();
}

type SitrepPresenceAvatarsProps = {
  viewers: SitrepPresenceViewer[];
  className?: string;
};

export const SitrepPresenceAvatars: React.FC<SitrepPresenceAvatarsProps> = ({
  viewers,
  className,
}) => {
  if (!viewers.length) return null;

  const names = viewers.map((v) => v.displayName).join(', ');

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger
          render={
            <div
              className={cn('tw:flex tw:items-center tw:gap-1', className)}
              aria-label={`Also viewing: ${names}`}
            >
              <span className="tw:mr-1 tw:text-xs tw:text-muted-foreground">
                Viewing
              </span>
              {viewers.slice(0, 6).map((viewer) => (
                <span
                  key={viewer.userGuid}
                  className="tw:inline-flex tw:size-7 tw:items-center tw:justify-center tw:rounded-full tw:text-[11px] tw:font-semibold tw:text-white"
                  style={{ backgroundColor: viewer.color }}
                >
                  {initials(viewer.displayName)}
                </span>
              ))}
              {viewers.length > 6 && (
                <span className="tw:text-xs tw:text-muted-foreground">
                  +{viewers.length - 6}
                </span>
              )}
            </div>
          }
        />
        <TooltipContent className="dark">{names}</TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};
